import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsInformationBarrierEnabled = () => boolean;
export const useIsInformationBarrierEnabled: UseIsInformationBarrierEnabled = () => {
  const isInformationBarrierEnabled = useExperimentTreatmentWithoutReporting('VivaEngagePremium') === true;

  return isInformationBarrierEnabled;
};
